import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid, parseOptions} from '../question-helper';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';

declare const $: any;

@Component({
    selector: 'app-question-vehicle-risk-list',
    templateUrl: './question-vehicle-risk-list.component.html',
    styleUrls: ['./question-vehicle-risk-list.component.scss'],
    standalone: false
})
export class QuestionVehicleRiskListComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();

  maskOptions: NgxCurrencyConfig;
  options: any[] = [];
  enteredItems: any[] = [];
  itemId = 1;
  uniqueValueName = `item-value-${newGuid()}`;
  uniqueRegNumberName = `item-value-${newGuid()}`;
  answers = [];
  childrenQuestions: Question[] = [];

  constructor(public questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    if (this.question?.options) {
      this.options = parseOptions(this.question.options);
      this.questionService.getItemList(this.question.cent_aq_question_id).subscribe(items => {
        if (items.length>0){
          items.forEach(item => {
            if (this.question.item_id == item.item_id){
              var d = item.details.split('|');
              this.enteredItems = [{ItemId: item.item_id, RegistrationNumber: d[2], Value: d[1], TrackingDevice: d[0], Premium: item.prem_value}];
            }
          });
          //this.question.answer = "Answered";
          this.questionAnswer.emit(this.question);

        }
        else{
          this.enteredItems = [{ItemId: this.itemId, RegistrationNumber: '', Value: '', TrackingDevice: '', Premium: 0}];
        }
        //this.saveValue();

      });

    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: this.question?.max_val,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: 'R ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  addAnother(): void {
    if (this.enteredItems.every(item => item.RegistrationNumber && item.Value && item.TrackingDevice)) {
      this.itemId = (this.enteredItems[this.enteredItems.length - 1].ItemId + 1);
      this.enteredItems.push({ ItemId: this.itemId, RegistrationNumber: '', Value: '', TrackingDevice: '', Premium: 0});
    }
  }

  removeSpaces(value: string): string {
    return value.replace(/\s/g, '-').replace(/[^\w\s]/gi, '-');
  }

  upperCaseRegistration(index: number): void {
      this.enteredItems[index].RegistrationNumber = this.enteredItems[index]?.RegistrationNumber.toString().toUpperCase();
  }

  selectChange(value: string, index: number): void {
    this.enteredItems[index].TrackingDevice = value;
    this.itemId = this.enteredItems[index].ItemId;
    this.saveValue();
  }

  onInputChange(): void {
    this.saveValue();
  }

  saveValue(): void {
    if (this.question && this.enteredItems.every(item => item.RegistrationNumber && item.Value && item.TrackingDevice)) {
      this.processItems();
      // for (let i = 0; i <= this.enteredItems.length; i++) {
      //   try {
      //     let value = '';
      //     value += this.enteredItems[i].TrackingDevice + '|';
      //     value += this.enteredItems[i].Value + '|';
      //     value += this.enteredItems[i].RegistrationNumber;
      //     this.itemId = this.enteredItems[i].ItemId;
      //     this.answers.push(value);
      //     this.getPremium(i, value);
      //   }
      //   catch { }
      // }
    }
  }
  processItems(): void {
    this.enteredItems.forEach(item => {
      let value = '';
      value += item.TrackingDevice + '|';
      value += item.Value + '|';
      value += item.RegistrationNumber;
      this.question.answer = value;
      this.questionService.saveIndividualAnswer(this.question, item.ItemId)
      .subscribe(x => {
        if (x) {
          this.questionService.getPremium(this.question.product_class_id, item.ItemId, this.question?.product_id)
            .subscribe(r => {
               if (r?.length){
                item.Premium = r[0]?.premium;
               }
            });
        }
      });
    });
    this.questionAnswer.emit(this.question);
  }
  getPremium(index: any, answer: any): void {
    this.question.answer = answer;
    const item_id = index + 1;
    this.question.item_id = item_id.toString();
    this.questionService.saveIndividualAnswer(this.question, this.question.item_id)
      .subscribe(x => {
        if (x) {
          this.questionService.getPremium(this.question.product_class_id, this.question.item_id, this.question?.product_id)
            .subscribe(r => {
              if (r?.length && this.enteredItems[index].ItemId === this.question.item_id) {
                this.enteredItems[index].Premium = r[0]?.premium;
              }
              this.questionAnswer.emit(this.question);
            });
        }
      });
  }
}
